<mat-toolbar class="mat-toolbar-main-menu">
  <mat-toolbar-row class="app-head">
    @if (checkIfLoggedIn()) {
      <button
        mat-icon-button
        (click)="AppNavDrawer.toggle()"
        (click)="AppHelpDrawer.toggle(false)"
        matTooltip="Menu"
        [matTooltipPosition]="'below'">
        <mat-icon class="app-menu" aria-label="Navigation drawer icon">
          menu
        </mat-icon>
      </button>
    }
    <div class="app-logo">
      <img [src]="uriEbbLogo" [alt]="uriEbbLogoAltText" style="height: 35px " >
    </div>

 


  <span class="app-menu-spacer" fxShow.gt-xs="true" fxShow="false"></span>

  <span
    class="app-title" fxShow.gt-xs="true" fxShow="false" >
    <h1>{{currentUserType}} DASHBOARD</h1>
    @if (isMultiUserType) {
      <mat-icon
        id="walk1"
        class="dashboard-switch-icon"
        style="vertical-align: middle;"
        (click)="onClickSwitchDashboard()"
        matRipple
        [matRippleUnbounded]="'true'"
      [matRippleCentered]="'true'">expand_more</mat-icon>
    }
  </span>


  <!-- app tool bar -->
  <span class="app-menu-spacer"></span>

  <!-- Icons-->
  <span fxShow.md="true" fxShow="false" [title]="'Name: ' + currentUserName">{{currentUserName | truncate: 15 }}</span>
  <span fxShow.gt-md="true" fxShow="false" [title]="'Name: ' + currentUserName">{{currentUserName }}</span>

  @if (checkIfLoggedIn()) {
    <div>
      <button mat-icon-button
        matTooltip="User Account"
        [matTooltipPosition]="'below'"
        [matMenuTriggerFor]="menu" >
        <mat-icon style="color: #377491"  aria-label="Exit application">
          account_circle
        </mat-icon>
      </button>
      <mat-menu #menu='matMenu'>
        <button mat-menu-item [routerLink]='["/account"]'>
          <mat-icon>perm_identity</mat-icon>
          <span>User Account</span>
        </button>
        @if (isMobile && isMultiUserType) {
          <button mat-menu-item (click)="onClickSwitchDashboard()">
            <mat-icon  aria-label="Switch Dashboard">
              manage_accounts
            </mat-icon>
            <span>Select Your Dashboard</span>
          </button>
        }
        <button mat-menu-item (click)="userLogout()">
          <mat-icon>exit_to_app</mat-icon>
          <span>Log Out</span>
        </button>
      </mat-menu>
    </div>
  }

  <button mat-icon-button
    matTooltip="Show help"
    [matTooltipPosition]="'below'"
    (click)="onShowHelpDrawer()"
    (click)="AppHelpDrawer.toggle()">
    <mat-icon style="color: #377491" aria-label="Online help">
      help
    </mat-icon>
  </button>
</mat-toolbar-row>
</mat-toolbar>

<mat-drawer-container class="mat-drawer-main-menu">
  <mat-drawer #AppNavDrawer [mode]="modeMainMenu" [(opened)]="isMainMenuOpen" [push]="isMainMenuPush">
 <mat-nav-list style="margin: 12px;" class="no-bullets">

  @if (checkIfLoggedIn()) {
    @for (item of appMenuItems; track item) {
      <a
        mat-list-item
        [id]="item.linkAction"
        (click)="navigateToPage($event)">

        <mat-icon matListItemIcon aria-label="{{ item.linkName }}">
          {{ item.iconName }}
        </mat-icon>

        <span matListItemTitle>{{ item.linkName }}</span>
      </a>
    }
  }

  <a mat-list-item (click)="onShowHelpDrawer(); AppHelpDrawer.toggle()">
    <mat-icon matListItemIcon aria-label="Online Help">help_outline</mat-icon>
    <span matListItemTitle>Online Help</span>
  </a>

  <a mat-list-item (click)="userLogout()">
    <mat-icon matListItemIcon aria-label="Log out">exit_to_app</mat-icon>
    <span matListItemTitle>Log out</span>
  </a>

</mat-nav-list>


  </mat-drawer>

  <mat-drawer-content>

    <router-outlet></router-outlet>
  </mat-drawer-content>

  <mat-drawer #AppHelpDrawer mode="over" position="end" >
    <div style="margin: 18px 9px 12px 9px; max-width: 300px;">
      <div style="display: inline;">
        <span>Online Help</span>
        <a href="javascript:void(0)" (click)="AppHelpDrawer.toggle()">
          <mat-icon color="primary" style="float: right;">arrow_forward</mat-icon>
        </a>
      </div>
      <br />
      <br />
      <form [formGroup]="formHelpSelect">
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Select help topic</mat-label>
            <select matNativeControl
              (change)="onChangeHelpTopicEvent($event.target.value)"
              formControlName="selectHelp">
              @for (topic of listHelpTopic; track topic) {
                <option [value]="topic">
                  {{topic}}
                </option>
              }
            </select>
          </mat-form-field>
        </div>
      </form>
      @if (AppHelpDrawer.opened) {
        <div>
          @for (item of listHelpTopicItem; track item) {
            <div style="width: 100%; max-width: 280px;">
              <h6 style="margin-top: 9px; font-size: 14px; font-weight: bold;">
                {{item.question}}
              </h6>
              <div [innerHTML]="item.answerSafe" style="width: 100%; font-size: 13px;"></div>
            </div>
          }
        </div>
      }
    </div>

  </mat-drawer>

</mat-drawer-container>

<!-- <ngx-guided-tour ></ngx-guided-tour> -->

<ebb-portal-app-foot></ebb-portal-app-foot>
